module.exports = __webpack_public_path__ + "static/media/location.34902615.svg";